import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "Comment intégrer OuiGoo à ma boutique en ligne ?",
      answer: "Vous pouvez intégrer OuiGoo en quelques minutes via nos extensions pour Shopify et WordPress, ou en utilisant notre API REST pour une solution personnalisée."
    },
    {
      question: "Quels sont les coûts associés à l'utilisation de OuiGoo ?",
      answer: "Notre service est gratuit. Vous ne payez que les frais de livraison pour chaque commande traitée."
    },
    {
      question: "Puis-je suivre les livraisons en temps réel ?",
      answer: "Oui, OuiGoo offre un suivi en temps réel pour toutes vos livraisons, vous permettant de savoir exactement où se trouvent vos colis à tout moment."
    },
    {
      question: "Comment fonctionne la gestion des retours ?",
      answer: "Nous gérons les retours de colis pour vous. Si un client souhaite retourner un produit, nous organisons le retrait et le renvoi à votre boutique."
    },
    {
      question: "Quelles zones géographiques sont couvertes par OuiGoo ?",
      answer: "OuiGoo couvre actuellement plusieurs pays d'Afrique. Contactez-nous pour vérifier la disponibilité dans votre région spécifique."
    }
  ];

  return (
    <section id="faq" className="py-16 bg-white">
      <div className="container mx-auto">
        <div className="md:flex md:space-x-12">
          {/* Left Column: Title and Subtitle */}
          <div className="md:w-1/3 mb-12 md:mb-0">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 animate-on-scroll">
              <span className="bg-primary-custom px-2">Foire Aux Questions</span>
            </h2>
            <p className="text-gray-600 animate-on-scroll">
              Vous avez d'autres questions ? N’hésitez pas à nous <a href="/contact" className="underline">contacter</a>.
            </p>
          </div>

          {/* Right Column: FAQ Items */}
          <div className="md:w-2/3">
            <div>
              {faqItems.map((item, index) => (
                <div key={index} className="border-t border-gray-200 animate-on-scroll">
                  <button
                    className="faq-toggle w-full py-5 px-4 text-left flex justify-between items-center focus:outline-none"
                    onClick={() => toggleFAQ(index)}
                  >
                    <h3 className={`text-xl font-semibold ${activeIndex === index ? 'text-primary-custom' : ''}`}>{item.question}</h3>
                    <span className={`text-2xl transform transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`}>
                      {activeIndex === index ? '−' : '+'}
                    </span>
                  </button>
                  <div
                    className={`px-4 overflow-hidden transition-all duration-300 ease-in-out ${
                      activeIndex === index ? 'max-h-96 opacity-100 pb-5' : 'max-h-0 opacity-0 pb-0'
                    }`}
                  >
                    <p className="text-gray-600">{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
